import { ComponentProps } from 'react';
import { bordColorTheme } from '../../../../styles/styles.constants';

const BordBoxStepsIcon = (props: ComponentProps<'svg'>) => {
  const { stroke, ...rest } = props;
  const strokeColor = stroke || bordColorTheme.stroke.default;

  return (
    <svg viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg" {...props} stroke={strokeColor} {...rest}>
      <path
        d="M13.0016 21.9992C12.1834 21.9992 11.4017 21.658 9.83849 20.9757C8.01389 20.1792 6.61711 19.5695 5.64804 18.9992H2.00156M13.0016 21.9992C13.8198 21.9992 14.6014 21.658 16.1647 20.9757C20.0559 19.2771 22.0016 18.4278 22.0016 16.9992V6.49922M13.0016 21.9992V10.9992M4.00157 6.49922V9.49922"
        stroke={strokeColor}
        strokeWidth={2}
        strokeLinecap="round"
        strokeLinejoin="round"
      />

      <path
        d="M9.32904 9.6906L6.40783 8.27707C4.8047 7.50132 4.00157 7.11346 4.00157 6.49922C4.00157 5.88499 4.8047 5.49713 6.40783 4.72138L9.32904 3.30782C11.1319 2.43542 12.0333 1.99922 13.0016 1.99922C13.9698 1.99922 14.8712 2.43542 16.6741 3.30782L19.5952 4.72138C21.1984 5.49713 22.0016 5.88499 22.0016 6.49922C22.0016 7.11346 21.1984 7.50132 19.5952 8.27707L16.6741 9.6906C14.8712 10.563 13.9698 10.9992 13.0016 10.9992C12.0333 10.9992 11.1319 10.563 9.32904 9.6906Z"
        stroke={strokeColor}
        strokeWidth={2}
        strokeLinecap="round"
        strokeLinejoin="round"
      />

      <path
        d="M18.1397 4.01484L7.87032 8.98406"
        stroke={strokeColor}
        strokeWidth={2}
        strokeLinecap="round"
        strokeLinejoin="round"
      />

      <path
        d="M2.00156 12.9996H5.00156"
        stroke={strokeColor}
        strokeWidth={2}
        strokeLinecap="round"
        strokeLinejoin="round"
      />

      <path
        d="M2.00156 15.9996H5.00156"
        stroke={strokeColor}
        strokeWidth={2}
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
};

export default BordBoxStepsIcon;
